import { Component, Input, ChangeDetectionStrategy } from "@angular/core";
import * as _ from "lodash";
import { TeamMember } from "@teammood/team";
import { setHours, setMinutes, format, startOfDay, parse, endOfDay, isBefore, isAfter } from "date-fns";
import { TranslateModule } from "@ngx-translate/core";
import { CommonModule } from "@angular/common";
import { OutOfOffice } from "@teammood/shared/ui/out-of-office";
import { MatTooltipModule } from "@angular/material/tooltip";

@Component({
    selector: 'team-member',
    templateUrl: './team-member.component.html',
    styleUrls: ['./team-member.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        CommonModule,
        TranslateModule,
        MatTooltipModule
    ]
})
export class TeamMemberComponent {
   
    memberNotificationTimeTime: string;

    @Input() member: TeamMember;

    constructor() {}

    protected pausedUntil(outOfOffices: OutOfOffice[]) {
        const now = new Date();
        return _.find(outOfOffices, (ooo) => {
            const vacationStart = startOfDay(parse(ooo.from, "dd/MM/yyyy", new Date()))
            const vacationEnd = endOfDay(parse(ooo.to, "dd/MM/yyyy", new Date()))
            return isBefore(vacationStart, now) && isAfter(vacationEnd, now);
        });
    }

    protected renderTime(stringTime: string) {
        let longTime = new Date();
        const hours = stringTime.split(":")[0];
        const minutes = stringTime.split(":")[1];
        longTime = setHours(longTime, Number(hours));
        longTime = setMinutes(longTime, Number(minutes));

        return format(longTime, 'p');
    }
}